import { Spin } from 'antd';
import cn from '../lib/cn';

const Loader = () => {
  return (
    <div className="relative">
      <div
        className={cn(
          'fixed left-0 right-0 top-0 bottom-0 z-50 w-ful h-full flex items-center justify-center flex-col gap-2 dark:bg-slate-90',
          'bg-white text-theme-slate-900',
        )}
      >
        <Spin className="" size="large" />
        <span className="text-display-body font-medium text-sm ml-2">
          Loading...
        </span>
      </div>
    </div>
  );
};

export default Loader;
